import { render, staticRenderFns } from "./PanelsEditModal.vue?vue&type=template&id=827d51ba&scoped=true"
import script from "./PanelsEditModal.vue?vue&type=script&lang=js"
export * from "./PanelsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827d51ba",
  null
  
)

export default component.exports